/* eslint-disable angular/window-service */
/* eslint-disable angular/timeout-service */
/* eslint-disable angular/document-service */
import React, { useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { handleAIPromptFetch } from './hooks/aiAPI';

function positionModal(iconId, modalId) {
    const icon = document.getElementById(iconId);
    const modal = document.getElementById(modalId);

    if (icon && modal) {
        const iconRect = icon.getBoundingClientRect();
        const scrollTop = 0;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        modal.style.top = `${iconRect.bottom + scrollTop + 10}px`;
        const leftPosition = iconRect.left + scrollLeft + (iconRect.width / 2) - (modal.offsetWidth / 2);
        modal.style.left = `${Math.max(0, leftPosition)}px`;
    }
}
const AiMessagePrompt = ({ isOpen, onClose }) => {
    const emailContainer = document.getElementsByClassName('tv-rich-text-content');
    const [inputValue, setInputValue] = useState('');
    const [inputValues, setInputValues] = useState([]);
    const [promptResponse, setPromptResponse] = useState('');
    document.addEventListener('DOMContentLoaded', () => {
        const topDiv = document.querySelector('.top-div');
        const bottomDiv = document.querySelector('.bottom-div');
        const topDivHeight = topDiv.offsetHeight;
        bottomDiv.style.marginTop = topDivHeight + 'px';
    });

    useEffect(() => {
        if (isOpen) {
            positionModal('ai-icon', 'ai-modal');
            setInputValue(''); // Reset the input when modal is supposed to open

            const handleClickOutside = (event) => {
                const modalElement = document.getElementById('ai-modal');
                if (modalElement && !modalElement.contains(event.target)) {
                    onClose(); // Close modal on outside click
                }
            };

            document.addEventListener('mousedown', handleClickOutside);

            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
        return () => {};
    }, [isOpen]);

    useEffect(() => {
        if (isOpen) {
            const modalElement = document.getElementById('ai-modal');
            if (modalElement) {
                modalElement.setAttribute('aria-hidden', 'true');

                const focusableElements = modalElement.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                const firstFocusable = focusableElements[0];

                if (firstFocusable) {
                    firstFocusable.focus();
                }

                const handleTabKey = (e) => {
                    if (e.key === 'Tab') {
                        const focusable = Array.from(focusableElements);
                        const currentIndex = focusable.indexOf(document.activeElement);

                        if (e.shiftKey && currentIndex === 0) {
                            focusable[focusable.length - 1].focus();
                            e.preventDefault();
                        } else if (!e.shiftKey && currentIndex === focusable.length - 1) {
                            focusable[0].focus();
                            e.preventDefault();
                        }
                    }
                };

                modalElement.addEventListener('keydown', handleTabKey);

                return () => {
                    modalElement.removeEventListener('keydown', handleTabKey);
                    modalElement.removeAttribute('aria-hidden');
                };
            }
        }
        return () => {};
    }, [isOpen]);

    useEffect(() => {
        positionModal('ai-icon', 'ai-modal');
        window.addEventListener('resize', positionModal);

        return () => {
            window.removeEventListener('resize', positionModal);
        };
    }, []);

    const handleSubmit = async () => {
        onClose();
        if (inputValue.trim() !== '') {
            const newInputValues = [...inputValues, inputValue];
            setInputValues(newInputValues);
            // show cancel/regenerate button during the fetch
            window.dispatchEvent(new CustomEvent('setAiActionButton', { detail: { showButton: true } }));
            await handleAIPromptFetch(inputValue);
        }
        return () => {};
    };
    useEffect(() => {
        sessionStorage.setItem('ai-message-prompts', inputValue);
    }, [inputValue]);
    const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setViewportWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const getModalWidth = () => {
        if (viewportWidth <= 480) {
            return '90%';
        } if (viewportWidth <= 768) {
            return '80%';
        }
        return '450px';
    };

    const modalContent = (
        <Draggable
            cancel=".not-draggable"
        >
            <div
                id="ai-modal"
                className="ai-modal-container"
                style={{
                    position: 'fixed',
                    top: 'calc(130px + 15%)',
                    left: 'clamp(10%, 50%, 90%)',
                    transform: 'translateX(-50%)',
                    zIndex: 1050,
                    width: getModalWidth(),
                    maxWidth: '450px',
                    height: 'auto',
                    overflow: 'auto',
                    cursor: 'grab',
                }}
                role="dialog"
                aria-labelledby="ai-modal-title"
                aria-describedby="ai-modal-description"
            >
                <div className="ai-modal-header">
                    <button
                        className="ai-close-button"
                        onClick={onClose}
                        aria-label="Close AI modal"
                    >
                        <i className="fa fa-times" aria-hidden="true"></i>
                    </button>
                </div>
                <div className="ai-modal-content">
                    <h2 id="ai-modal-title" className="sr-only">AI Message Generator</h2>
                    <p id="ai-modal-description" className="sr-only">This modal allows you to generate customized AI messages.</p>
                    <div className="ai-modal-prompt-message">
                        <img width="25px" height="25px" src="/img/ai-icon.png" alt="AI icon" />
                        <p className="ai-text">Enter a prompt below to generate a customized AI message</p>
                    </div>
                </div>
                <div className='ai-modal-linebreak' role="separator" />
                <div className="ai-text-box-wrapper">
                    <label htmlFor="ai-input" className="sr-only">Enter AI prompt</label>
                    <textarea
                        id="ai-input"
                        type="text"
                        className="ai-text-box not-draggable"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSubmit(inputValue);
                                document.querySelector('.ai-button').focus();
                            }
                        }}
                        aria-label="Input Box for AI Email Messaging"
                    />
                    <button
                        className="ai-button"
                        type="button"
                        onClick={() => handleSubmit(inputValue)}
                        aria-label="Submit AI prompt"
                    >
                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </button>
                </div>
                {/* waiting for designs from Jordan on next steps. */}
                {/* {inputValues.length > 0
                && <div className='ai-prompts-list'>
                    <ul className='ai-prompts-wrapper-list'>
                        {inputValues.map((value, index) => (
                            <>
                                <li className='ai-prompt-list-element' key={index}>{value}</li> <i className="fa fa-repeat" aria-hidden="true"></i>
                            </>
                        ))}
                    </ul>
                </div>
                } */}
            </div>
        </Draggable>
    );



    return isOpen ? ReactDOM.createPortal(
        modalContent,
        document.body,
    ) : null;
};

AiMessagePrompt.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default AiMessagePrompt;
